/// <reference types="@types/googlemaps" />

import {
  Component,
  NgModule,
  OnInit,
  Injectable,
  Inject,
  ViewChild,
  ViewContainerRef,
  ElementRef,
  NgZone,
  AfterViewInit,
  ViewChildren,
  QueryList,
  HostListener
} from '@angular/core';

import { Location } from '@angular/common';

import { MapsAPILoader } from '@agm/core';

import { MetaDataService, TriageQuestion, TriageQuestionData, JobType, FAQItem, PricingChange } from '../services/meta-data.service';
import { Router } from '@angular/router';
import { JobDataService, HomeServiceItem, TriageResponseItem, JobBookingWindow, JobTimeWindow, JobData, InclusionData, InclusionSection } from '../services/job-data.service';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreModule } from '@angular/fire/firestore';

import { environment } from '../../environments/environment';
import { Clients, QuestionTypes, TradeTypes, ServiceTypes, JobChannelType, JobTypes } from '../services/globals.service';

import { faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { PricingService, TradeTypePricing, JobTypePricing } from '../services/pricing.service';
import { MatCalendar } from '@angular/material/datepicker';
import { PostcodeManagerService } from '../services/postcode-manager.service';
import { PopupService, SpecialPopupType } from '../services/popup.service';
import { ThrowStmt } from '@angular/compiler';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-triage',
  templateUrl: './triage.component.html',
  styleUrls: ['./triage.component.css']
})
export class TriageComponent implements OnInit {

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.jobDataService.trade.jobTypes.length == 1) {
      (<any>window).skipToHome = true;
    }
  }

  // fontawesome icons
  public faSpinner = faSpinner;
  public faTrash = faTrash;

  public isPublicHoliday(d: Date): boolean {
    return this.postcodeManager.SelectedPostcodeGroup.IsPublicHoliday(d);
  }

  public isDateOutOfHours(d: Date): boolean {
    const day = d.getDay();

    let publicHolidayCheck: boolean = this.isPublicHoliday(d);

    if (publicHolidayCheck) {
      return true;
    }

    if (day == 0 || day == 6) {
      return true;
    }

    return false;
  }

  public isOutOfHours(w: BookingWindow): boolean {
    if (w == null) {
      return false;
    }

    if (w.date == null || w.time == null) {
      return false;
    }

    if (this.isDateOutOfHours(w.date)) {
      return true;
    }

    if (w.time.outOfHours) {
      return true;
    }

    return false;
  }

  // 20220610 - MM - select the earliest non-blackout day
  public getCalendarStartDate(): Date {

    // 20220610 - MM - most distant future booking allowed is 120 days
    const numDaysToCheck: number = 120;
    var daysChecked: number = 0;

    // 20220610 - MM - increment days until the first non-blackout day is found
    const candidateDate = new Date();
    while (!this.dateFilter(candidateDate) && daysChecked < numDaysToCheck) {
      candidateDate.setDate(candidateDate.getDate() + 1);
      daysChecked += 1;
    }

    // 20220610 - MM - if no booking window are available, return todays date
    if (daysChecked == numDaysToCheck)
      return new Date();

    return candidateDate;
  }

  public dateFilter = (d: Date): boolean => {
    let blackoutDays = environment.defaultBlackoutDays;
    const today = new Date();
    const day = d.getDay();

    // disable any day before today
    if ((d.getTime() - today.getTime()) < 0) {
      return false;
    }

    if (this.postcodeManager.SelectedPostcodeGroup.OverrideBlackoutDays != null) {
      blackoutDays = this.postcodeManager.SelectedPostcodeGroup.OverrideBlackoutDays;
    }

    // does this trade type override the blackout days?
    if (this.jobDataService.trade.overrideBlackoutDays != null
      && this.jobDataService.trade.overrideBlackoutDays != -1) {
      blackoutDays = this.jobDataService.trade.overrideBlackoutDays;
    }

    // is there a region specific override for the blackout days?
    let tradeTypePricing = this.postcodeManager.SelectedPostcodeGroup.GetTradeTypePricing(this.jobDataService.trade.id);
    if (tradeTypePricing != null && tradeTypePricing.OverrideBlackoutDays != null) {
      blackoutDays = tradeTypePricing.OverrideBlackoutDays;
    }

    // allow next day bookings and is the current time before the cutoff?
    if (today.getHours() <= environment.nextDayBookingEnd && this.postcodeManager.SelectedPostcodeGroup.AllowNextDayBooking == true) {
      if (this.jobDataService.trade.nextDayBooking == true) {
        blackoutDays = 0;
      }
    }

    let publicHolidayCheck: boolean = this.isPublicHoliday(d);

    if (publicHolidayCheck) {
      if (this.outOfHoursEnabled == false) {
        return false;
      }
    }

    let msPerDay = 1000 * 3600 * 24;
    let diff = Math.abs(d.getTime() - today.getTime());
    let diffDays = Math.ceil(diff / msPerDay);

    // block out monday if the booking is being done on a weekend
    // monday = 1, saturday = 6, sunday = 0
    if (diffDays < 5 && environment.blockMondayOnWeekend && d.getDay() == 1 && (today.getDay() == 6 || today.getDay() == 0)) {
      return false;
    }

    let diffDaysThreshold = blackoutDays + 1;

    if (this.outOfHoursEnabled == false) {
      if (today.getDay() == 6) {
        diffDaysThreshold += 1;
      } else if (today.getDay() + blackoutDays >= 6) {
        diffDaysThreshold += 2;
      }
    }

    // only current day is blacked out for home inspections
    if (this.jobDataService.trade.id == this.tradeTypes.HomeInspections) {
      diffDaysThreshold = 1;
    }

    // disable blacked out days
    if (diffDays < diffDaysThreshold) {
      return false;
    }

    if (this.metaData.IsTradeTypeBlackoutDate(this.jobDataService.trade.id, this.jobDataService.postcode, d)) {
      return false;
    }

    // can't book more than 120 days in the future
    if (diffDays > 120) {
      return false;
    }

    if (this.outOfHoursEnabled == false) {
      // Prevent saturday and sunday from being selected if out of hours is not allowed
      return day !== 0 && day !== 6;
    } else {
      return true;
    }
  }

  public dateClass = (d: Date) => {
    if (this.outOfHoursEnabled == false) {
      return undefined;
    }

    if (this.dateFilter(d) == false) {
      return undefined;
    }

    let oohClass = 'outOfHoursDate';

    if (this.isDateOutOfHours(d)) {
      return oohClass;
    } else {
      return undefined;
    }
  }

  public specialPopupType = SpecialPopupType;

  public bundlingEnabled: boolean = environment.bundlingEnabled;

  public productName: string = environment.productName;
  public whereDidYouHearAboutUs: string = '';

  public triageQuestions: Array<TriageQuestionData> = [];
  public currentQuestion: TriageQuestionData = null;

  public standardModel: boolean = true;
  public calculatingPrice: boolean = false;

  public confirmEmail: string = '';

  // used to display discounts
  public fullPrice: number = 0;
  public discountApplied: boolean = false;
  public discountText: string = 'MEMBER PRICE';

  public currentPrice: number = 0;
  public estimatedDuration: number = 1;

  public stepsProgress: Array<boolean> = [];

  public showMoreDetails: boolean = false;
  public showFAQ: boolean = false;
  public showBackToQuestionsButtons: boolean = false;

  public showPopup: boolean = false;
  public popupContent: string = '';
  public showEndPopup: boolean = false;
  public endLoading: boolean = false;
  public showLocksmithPopup: boolean = false;
  public showHandymanPopup: boolean = false;
  public showGoBackPopup: boolean = false;
  public showCarpentryPopup: boolean = false;
  public showcommonHVACMaintenaceJobsPopup: boolean = false;
  public showcommonHVACRepairJobsPopup: boolean = false;
  public showHealthyHomesPopup: boolean = false;

  public showDeleteServicePopup: boolean = false;
  public deletingJobType: JobType = null;

  public showAddServicesPopup: boolean = false;

  public faqItems: Array<FAQItem> = [];
  public commonHandymanJobs: Array<string> = [];
  public commonLocksmithJobs: Array<string> = [];
  public commonCarpentryJobs: Array<string> = [];
  public commonHVACMaintenaceJobs: Array<string> = [];
  public commonHVACRepairJobs: Array<string> = [];

  public bookingPhotos: Array<BookingPhoto> = [];

  public timeWindowOptions: Array<TimeWindow> = [];
  public bookingWindows: Array<BookingWindow> = [];
  public currentBookingWindow: number = 0;
  public showBookingWindow: boolean = false;
  public selectedBookingDate: Date = null;
  public selectedBookingTime: TimeWindow = null;
  public showTimeWindowDropdown: boolean = false;
  public currentBookingOptionValid: boolean = false;
  public currentWindowOutOfHours: boolean = false;

  public addressRef: ElementRef;

  public siteContactSameAsBooking: boolean = false;
  public agreeTermsPrivacy: boolean = false;
  //public agreePriceEstimate: boolean = false;
  public agreeCallout: boolean = false;
  public agreePayNow: boolean = false;
  public agreePayment: boolean = false;
  // public agreeCovid: boolean = false;
  // public agreeDogs: boolean = false;
  public marketingOptIn: boolean = false;
  public confirmJobClicked: boolean = false;

  public clientID: number = 0;

  public currentJobTypeIndex: number = 0;

  // make it accessible in the component html
  public outOfHoursEnabled: boolean = environment.outOfHoursEnabled;
  public outOfHoursPriceApplied: boolean = false;

  public showOfferMessage: boolean = false;
  public offerSuccess: boolean = false;
  public applyFlatDiscount: boolean = false;
  public flatDiscount: number = 0;

  public offerTheBlock: boolean = false;
  public offerBenefits: boolean = false;
  public benefitsApplied: boolean = false;

  public bookingWindowsEnabled = environment.showBookingWindows;

  public addServicesList: Array<JobTypeSelector> = [];

  public pricingInfoEnabled = environment.showPricingInfo;
  public showCheckboxMandatoryIndicator = environment.mandatoryCheckboxIndicatorsEnabled;
  public checkboxMandatoryIndicator = environment.mandatoryCheckboxIndicatorsEnabled ? '* ' : '';

  // #region Country Code Phone Input
  public itiPhoneNumber: any = null;
  public itiSitePhoneNumber: any = null;

  public phoneNumberChanged(): void {
    this.jobDataService.jobData.customerContact.contactPhone = this.itiPhoneNumber.getNumber();
    this.validateOnChange();
  }

  public sitePhoneNumberChanged(): void {
    this.jobDataService.jobData.siteContact.contactPhone = this.itiSitePhoneNumber.getNumber();
    this.validateOnChange();
  }

  public siteContactSameAsBookingChanged(): void {
    if (this.siteContactSameAsBooking) {
      this.jobDataService.jobData.siteContact.contactName = this.jobDataService.jobData.customerContact.contactName;
      this.jobDataService.jobData.siteContact.contactPhone = this.jobDataService.jobData.customerContact.contactPhone;

      if (this.itiSitePhoneNumber != null && this.jobDataService.jobData.siteContact.contactPhone) {
        this.itiSitePhoneNumber.setNumber(this.jobDataService.jobData.siteContact.contactPhone);
      }
    }

    this.validateOnChange();
  }

  @ViewChild('phoneNumber', { static: false }) set contentPhoneNumber(content: ElementRef) {
    if ((content === undefined || content === null)
      && this.itiPhoneNumber != null) {
      this.itiPhoneNumber = null;
    }

    if (content === undefined || content === null || this.itiPhoneNumber != null) {
      return;
    }

    const input = content.nativeElement;

    this.itiPhoneNumber = (<any>window).intlTelInput(input, {
      preferredCountries: environment.countryCodeSelectorCountries,
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
      separateDialCode: true,
    });

    if (this.jobDataService.jobData.customerContact.contactPhone) {
      this.itiPhoneNumber.setNumber(this.jobDataService.jobData.customerContact.contactPhone);
    }

    input.addEventListener('countrychange', () => {
      this.phoneNumberChanged();
    });
  }

  @ViewChild('sitePhoneNumber', { static: false }) set contentSitePhoneNumber(content: ElementRef) {
    if (content === undefined || content === null) {
      return;
    }

    const input = content.nativeElement;

    this.itiSitePhoneNumber = (<any>window).intlTelInput(input, {
      preferredCountries: environment.countryCodeSelectorCountries,
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
      separateDialCode: true,
    });

    if (this.jobDataService.jobData.siteContact.contactPhone) {
      this.itiSitePhoneNumber.setNumber(this.jobDataService.jobData.siteContact.contactPhone);
    }

    input.addEventListener('countrychange', () => {
      this.sitePhoneNumberChanged();
    });
  }
  // #endregion

  @ViewChild('address', { static: false }) set content(content: ElementRef) {
    if (content === undefined || content === null) {
      return;
    }

    this.addressRef = content;

    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.addressRef.nativeElement, {
        types: ["address"]
      });

      autocomplete.setComponentRestrictions({ 'country': environment.googleMapsCountries });

      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          } else {
            // valid
            let streetNumber = '';
            let streetName = '';
            let postcode = '';
            let suburbName = '';
            let country = '';
            let unit = '';

            let administrative_area_level_1 = '';
            let locality = '';

            place.address_components.forEach(s => {
              s.types.forEach(t => {
                if (t == "country") {
                  country = s.short_name;
                }
              });
            });

            place.address_components.forEach(s => {
              s.types.forEach(t => {
                if (t == 'street_number') {
                  streetNumber = s.long_name;
                } else if (t == 'route') {
                  streetName = s.long_name;
                } else if (t == 'postal_code') {
                  postcode = s.long_name;
                } else if (t == 'locality') {
                  locality = s.long_name;

                  if (country.toUpperCase() == 'AU') {
                    suburbName = s.long_name;
                  }
                } else if (t == 'sublocality') {
                  if (country.toUpperCase() == 'NZ') {
                    suburbName = s.long_name;
                  }
                } else if (t == "subpremise") {
                  unit = s.long_name;
                }
                else if (t == 'administrative_area_level_1') {
                  administrative_area_level_1 = s.long_name;
                }
              });
            });

            // for some reason NZ addresses sometimes rarely return the suburb name in locality instead of sublocality
            if (country.toUpperCase() == 'NZ' && suburbName.length == 0 && locality.length > 0) {
              suburbName = locality;
            }

            // try to auto remove accent characters/diacritics
            suburbName = suburbName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            streetName = streetName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            this.jobDataService.jobData.postcode = postcode;
            this.jobDataService.jobData.suburbName = suburbName;
            this.jobDataService.jobData.streetAddress = streetNumber + ' ' + streetName;
            this.jobDataService.jobData.streetUnit = unit;
          }
        });
      });
    });
  } // address setter

  constructor(
    public metaData: MetaDataService,
    public router: Router,
    public jobDataService: JobDataService,
    public mapsAPILoader: MapsAPILoader,
    public ngZone: NgZone,
    public toastr: ToastrService,
    public db: AngularFirestore,
    public pricingService: PricingService,
    public clients: Clients,
    public questionTypes: QuestionTypes,
    public tradeTypes: TradeTypes,
    public jobTypes: JobTypes,
    public location: Location,
    public postcodeManager: PostcodeManagerService,
    public popupService: PopupService,
    public languageService: LanguageService
  ) {
    this.clientID = environment.clientID;

    if (this.jobDataService.jobTypes.length == 0) {
      this.router.navigate(['/home']);
      return;
    }

    if (this.jobDataService.trade.oohHourlyRate == null || this.jobDataService.trade.oohHourlyRate == 0) {
      this.outOfHoursEnabled = false;
    }

    this.jobDataService.offerCode = '';

    let jobTypeIndex: number = 0;
    let questionIndex: number = 0;

    this.currentJobTypeIndex = 0;

    this.jobDataService.reset();

    this.jobDataService.jobTypes.forEach(jt => {
      jt.questions.forEach(q => {
        let questionData = new TriageQuestionData();
        questionData.question = q;
        questionData.show = false;
        questionData.index = questionIndex;
        questionData.answer = q.defaultAnswer;
        questionData.fullAnswer = questionData.answer;
        questionData.jobTypeIndex = jobTypeIndex;
        this.triageQuestions.push(questionData);

        if (jt.firstQuestionIndex == null || jt.firstQuestionIndex < 0) {
          jt.firstQuestionIndex = questionIndex;
        }

        questionIndex += 1;
      });

      jt.currentBasePartsCost = jt.partsCostBase;
      jt.currentPremiumPartsCost = jt.partsCostPremium;
      jt.jobTypeIndex = jobTypeIndex;
      jt.currentAttendanceHours = jt.attendanceHours;
      jt.currentHourlyMultiplier = null;

      jt.estimatedCurrentPrice = 0;
      jt.estimatedFullPrice = 0;
      jt.estimatedDuration = jt.attendanceHours;
      jt.currentQuantity = 1;

      jt.standardModel = true;

      jobTypeIndex += 1;
    });

    this.metaData.standardQuestions.forEach(q => {
      let questionData = new TriageQuestionData();

      questionData.question = q;
      questionData.show = false;
      questionData.index = questionIndex;
      questionData.answer = q.defaultAnswer;
      questionData.fullAnswer = questionData.answer;
      questionData.jobTypeIndex = -100;

      // 20220621 - MM - if showJobPhotos (from JSON) is false, don't push that job type to list 
      // 20220621 - MM - for context, this is used so we can attach a custom popup message to the job photos question in triage
      if (questionTypes.JobNotesPhotos == q.questionTypeID) {
        if (jobDataService.jobTypes[this.currentJobTypeIndex].showJobPhotos != false) {
          this.triageQuestions.push(questionData);
          questionIndex += 1;
        }
      } else if (questionTypes.BookingWindows == q.questionTypeID) {

        if (this.bookingWindowsEnabled) {
          this.triageQuestions.push(questionData);
          questionIndex += 1;
        }

      } else {
        this.triageQuestions.push(questionData);
        questionIndex += 1;
      }


    });

    this.bookingPhotos.length = 0;

    if (this.triageQuestions.length > 0) {
      this.triageQuestions[0].show = true;
      this.currentQuestion = this.triageQuestions[0];
      this.metaData.currentTriageQuestion = this.currentQuestion;

      if (this.currentQuestion.question.startPricing == true) {
        this.calculatingPrice = true;
        this.calculatePrice();
      }
    }

    this.stepsProgress.push(true);
    this.stepsProgress.push(false);
    this.stepsProgress.push(false);
    this.stepsProgress.push(false);

    this.bookingWindows.push(new BookingWindow());
    this.bookingWindows.push(new BookingWindow());

    this.updateAddServicesList();

    let component = this;

    environment.bookingWindows.forEach(function (w) {
      // booking windows defined in the client's environment file
      if (w.outOfHours == true && component.outOfHoursEnabled == false) {
        // don't add out of hours windows when it's disabled
      } else {
        component.timeWindowOptions.push(new TimeWindow(w.start, w.end, w.outOfHours));
      }
    });

    if (this.validateStep(false) == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }

    let providerName: string = 'Global Home Response';

    if (component.clientID == component.clients.AANZ) {
      providerName = environment.productName;
    }

    // DEFAULT VALUES
    if (this.jobDataService.jobTypes[this.currentJobTypeIndex].showGeneralNotes == null) {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].showGeneralNotes = true;
    }

    if (this.jobDataService.jobTypes[this.currentJobTypeIndex].showJobPhotos == null) {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].showJobPhotos = true;
    }

    let tradie: string = 'Tradie';
    if (this.clientID == this.clients.AANZ) {
      tradie = 'representative';
    }

    let tradies: string = 'Tradies';
    if (this.clientID == this.clients.AANZ) {
      tradies = 'representatives';
    }

    if (this.clientID == this.clients.AANZ) {
      this.faqItems.push(new FAQItem('Can I book a job for the Tradesperson/Inspector to come onsite to provide quotation?', 'No, please note booking our Tradesperson/Inspector to come to your property is a chargeable event.'));
      this.faqItems.push(new FAQItem('What payment methods are available?', 'For safety and convenience, ' + providerName + ' is cashless. For all services aside from home inspections, your payment is processed securely and easily on Visa, MasterCard or Debit Card via a link texted to you on completion of the works. Please note, payment for this service is due on completion of the job and expected immediately. For home inspection services, payment options and your invoice will be sent in the booking confirmation email. Payment must be received before you are able to view your report.'));

    }

    this.faqItems.push(new FAQItem('How do I know that I’m getting a fair price?', providerName + ' provides our ' + tradies + ' with consistent workflow, systems and processes to help them manage and grow their business efficiently. This results in you receiving a high-quality service at a fair price.'));
    this.faqItems.push(new FAQItem('How will I know if my booking has been confirmed?', 'You will receive an email and SMS confirmation for one of the booking windows of your choice. If for some reason we can’t achieve one of your requested times we will be in touch to organise another time that suits you.'));
    this.faqItems.push(new FAQItem('When can I book a job?', 'You can book within two hour booking windows commencing at 8.30am and ending at 4.30pm, Monday to Friday (excluding Public Holidays and weekends).'));
    this.faqItems.push(new FAQItem('What if the job takes longer/shorter than I booked for?', 'There is a minimum charge for all job bookings. Please note that the estimated cost provided to you during your booking journey, will be the minimum amount payable. Our ' + tradie + ' will review the information you have provided when the booking was made and will inform you whether there will be any additional time required to complete the job. If you are still happy to continue with the job, you will be able to sign off the additional charges to enable the Tradesperson/Inspector to proceed.'));
    this.faqItems.push(new FAQItem('What if the ' + tradie + ' wants me to pay them directly?', 'Payments should only be made via the secure payment link texted to you on completion of the works, or over the phone with an AA Home representative. For home inspection services, payment options and your invoice will be sent in the booking confirmation email. Payment must be received before you are able to view your report.'));
    this.faqItems.push(new FAQItem('When is payment due?', 'Payment for all services aside from home inspections are due on the completion of the job and are expected immediately. For home inspection services, payment options and your invoice will be sent in the booking confirmation email. Payment must be received before you are able to view your report.'));
    
    this.commonHandymanJobs.push('Leak repairs');
    this.commonHandymanJobs.push('Repair, plaster and paint hole in wall');
    this.commonHandymanJobs.push('Multiple small items');
    this.commonHandymanJobs.push('Multiple odd jobs');
    this.commonHandymanJobs.push('Picture hanging');
    this.commonHandymanJobs.push('Change light bulbs');
    this.commonHandymanJobs.push('Install hooks');
    this.commonHandymanJobs.push('Fit knobs & handles');
    this.commonHandymanJobs.push('Install towel rail');
    this.commonHandymanJobs.push('Gutter cleaning');
    this.commonHandymanJobs.push('Deck, paving, concrete cleaning');
    this.commonHandymanJobs.push('Water blasting');
    this.commonHandymanJobs.push('Install window latch or lock');
    this.commonHandymanJobs.push('Exterior house wash');
    this.commonHandymanJobs.push('Appliance fitting and installation');
    this.commonHandymanJobs.push('Roof cleaning');
    this.commonHandymanJobs.push('Fence & gate repairs');
    this.commonHandymanJobs.push('Hang & paint a door');
    this.commonHandymanJobs.push('Move furniture');
    this.commonHandymanJobs.push('Adjust sticking door');
    this.commonHandymanJobs.push('Balcony & deck staining');
    this.commonHandymanJobs.push('Installing cupboards and shelves');
    this.commonHandymanJobs.push('Furniture assembly');
    this.commonHandymanJobs.push('Replace cracked tiles and grout');
    this.commonHandymanJobs.push('Garden maintenance');
    this.commonHandymanJobs.push('Water tank installation');
    this.commonHandymanJobs.push('Garden shed assembly');

    this.commonHVACMaintenaceJobs.push('#PLANT');
    this.commonHVACMaintenaceJobs.push('Stop/Start Plant');
    this.commonHVACMaintenaceJobs.push('Check Operating Sequence');

    this.commonHVACMaintenaceJobs.push('#INDOOR UNIT');
    this.commonHVACMaintenaceJobs.push('Check filter and clean where necessary');
    this.commonHVACMaintenaceJobs.push('Check supply and return air grilles');
    this.commonHVACMaintenaceJobs.push('Check on/off coil temperature');
    this.commonHVACMaintenaceJobs.push('Check fan bearings');
    this.commonHVACMaintenaceJobs.push('Check coil and clean as necessary');
    this.commonHVACMaintenaceJobs.push('Check condensate tray and lines and clean as necessary');
    this.commonHVACMaintenaceJobs.push('Check all ducting is secure and without restriction where possible');

    this.commonHVACMaintenaceJobs.push('#OUTDOOR UNIT');
    this.commonHVACMaintenaceJobs.push('Check isolation switch');
    this.commonHVACMaintenaceJobs.push('Check crankcase heater (where applicable)');
    this.commonHVACMaintenaceJobs.push('Check refrigerant charge');
    this.commonHVACMaintenaceJobs.push('Check pressure and switch settings');
    this.commonHVACMaintenaceJobs.push('Check reversing valve operation');
    this.commonHVACMaintenaceJobs.push('Check setting and calibration of controls');
    this.commonHVACMaintenaceJobs.push('Check coil and clean where necessary');

    this.commonHVACMaintenaceJobs.push('#ELECTRICAL');
    this.commonHVACMaintenaceJobs.push('Check controls for arcing');
    this.commonHVACMaintenaceJobs.push('Check all connections for damage/tightness');
    this.commonHVACMaintenaceJobs.push('Check electric heaters where applicable');
    this.commonHVACMaintenaceJobs.push('Check remote batteries');

    this.commonHVACRepairJobs.push('Heat Pump or Air Conditioning not turning on');
    this.commonHVACRepairJobs.push('Not Heating or Cooling');
    this.commonHVACRepairJobs.push('Making unusual noise');
    this.commonHVACRepairJobs.push('Leaking water');

    this.commonLocksmithJobs.push('Re-key locks');
    this.commonLocksmithJobs.push('Door not closing');
    this.commonLocksmithJobs.push('Install window locks');
    this.commonLocksmithJobs.push('Upgrade security of the property');
    this.commonLocksmithJobs.push('My front door lock isn’t working');
    this.commonLocksmithJobs.push('I need all my locks changed');
    this.commonLocksmithJobs.push('Lost our roller door keys');
    this.commonLocksmithJobs.push('Install dead locks to apartments');

    this.commonCarpentryJobs.push('Door repairs');
    this.commonCarpentryJobs.push('Wall repairs');
    this.commonCarpentryJobs.push('Gyprocking');
    this.commonCarpentryJobs.push('Wall framing');
    this.commonCarpentryJobs.push('Deck extensions');
    this.commonCarpentryJobs.push('Patio extensions');
    this.commonCarpentryJobs.push('Repairs to skirting boards');
    this.commonCarpentryJobs.push('Tile replacements');
    this.commonCarpentryJobs.push('Stairway alterations');
    this.commonCarpentryJobs.push('Kitchen cabinetry alterations');
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  } // onInit

  public getQuestionDesc(question: TriageQuestionData): string {
    if (this.jobDataService.trade.overrideQuestionDesc != null) {
      let overrideDesc = this.jobDataService.trade.overrideQuestionDesc[question.question.questionTypeID.toString()];

      if (overrideDesc != null) {
        return this.languageService.getString(overrideDesc);
      }
    }

    return question.question.description;
  }

  public togglecommonHVACRepairJobsPopup(value: boolean): void {
    this.showcommonHVACRepairJobsPopup = value;
  }

  public togglecommonHVACMaintenaceJobsPopup(value: boolean): void {
    this.showcommonHVACMaintenaceJobsPopup = value;
  }

  public toggleLocksmithPopup(value: boolean): void {
    this.showLocksmithPopup = value;
  }

  public toggleHandymanPopup(value: boolean): void {
    this.showHandymanPopup = value;
  }

  public toggleCarpentryPopup(value: boolean): void {
    this.showCarpentryPopup = value;
  }

  public toggleGoBackPopup(value: boolean): void {
    this.showGoBackPopup = value;
  }

  public toggleDeleteServicePopup(value: boolean): void {
    this.showDeleteServicePopup = value;
  }

  public toggleAddServicesPopup(value: boolean): void {
    this.showAddServicesPopup = value;
  }

  public toggleHealthyHomesPopup(value: boolean): void {
    this.showHealthyHomesPopup = value;
  }

  public openDeleteServicePopup(jobType: JobType): void {
    this.deletingJobType = jobType;
    this.toggleDeleteServicePopup(true);
  }

  public closeDeleteServicePopup(answer: boolean): void {
    if (answer == true) {
      this.deleteService(this.deletingJobType);
      this.deletingJobType = null;
    }

    this.toggleDeleteServicePopup(false);
  }

  public deleteService(jobType: JobType): void {
    if (jobType == null) {
      return;
    }

    if (this.jobDataService.jobTypes.length <= 1) {
      this.toggleGoBackPopup(true);
      return;
    }

    let index: number = 0;
    let deleteIndex: number = -1;

    this.jobDataService.jobTypes.forEach(jt => {
      if (jt.productCode == jobType.productCode) {
        deleteIndex = index;
      }
      index += 1;
    });

    if (deleteIndex > -1) {
      this.jobDataService.jobTypes.splice(deleteIndex, 1);

      let jobTypeIndex: number = 0;

      this.jobDataService.jobTypes.forEach(jt => {
        jt.jobTypeIndex = jobTypeIndex;
        jobTypeIndex += 1;
      });

      let questionIndex: number = 0;
      let questionDeleteIndex: number = -1;
      let questionDeleteCount: number = 0;

      this.triageQuestions.forEach(q => {
        if (q.jobTypeIndex == deleteIndex) {
          if (questionDeleteIndex == -1) {
            questionDeleteIndex = questionIndex;
          }
          questionDeleteCount += 1;
        } else {
          if (questionDeleteIndex > -1 && q.jobTypeIndex != -100) {
            q.jobTypeIndex -= 1;
          }
        }

        questionIndex += 1;
      });

      if (questionDeleteIndex > -1) {
        this.triageQuestions.splice(questionDeleteIndex, questionDeleteCount);
      }

      this.fixIndexes();
      this.updateAddServicesList();
      this.goToStep(0);
      this.calculatePrice();
    }
  } // deleteService

  public addServicesFromPopup(): void {
    this.addServicesList.forEach(s => {
      if (s.selected == true) {
        let newJobTypeIndex: number = -1;

        this.jobDataService.jobTypes.forEach(jt => {
          if (jt.jobTypeIndex > newJobTypeIndex) {
            newJobTypeIndex = jt.jobTypeIndex;
          }
        });

        newJobTypeIndex += 1;

        this.jobDataService.jobTypes.push(s.jobType);

        let metaDataQuestionStart: number = -1;
        let tempIndex: number = 0;

        this.triageQuestions.forEach(q => {
          if (q.jobTypeIndex == -100 && metaDataQuestionStart == -1) {
            metaDataQuestionStart = tempIndex;
          }
          tempIndex += 1;
        });

        s.jobType.questions.forEach(q => {
          let questionData: TriageQuestionData = new TriageQuestionData();
          questionData.question = q;
          questionData.show = false;
          questionData.answer = q.defaultAnswer;
          questionData.fullAnswer = questionData.answer;
          questionData.jobTypeIndex = newJobTypeIndex;

          this.triageQuestions.splice(metaDataQuestionStart, 0, questionData);
          metaDataQuestionStart += 1;

          //if (s.jobType.firstQuestionIndex == null || s.jobType.firstQuestionIndex < 0) {
          //s.jobType.firstQuestionIndex = questionIndex;
          //}
        });

        s.jobType.currentBasePartsCost = s.jobType.partsCostBase;
        s.jobType.currentPremiumPartsCost = s.jobType.partsCostPremium;
        s.jobType.jobTypeIndex = newJobTypeIndex;
        s.jobType.currentAttendanceHours = s.jobType.attendanceHours;
        s.jobType.currentHourlyMultiplier = null;

        s.jobType.estimatedCurrentPrice = 0;
        s.jobType.estimatedFullPrice = 0;
        s.jobType.estimatedDuration = s.jobType.attendanceHours;
        s.jobType.currentQuantity = 1;
        s.jobType.standardModel = true;
      }
    });

    this.fixIndexes();
    this.updateAddServicesList();
    this.toggleAddServicesPopup(false);
    this.calculatePrice();
  }

  public updateAddServicesList(): void {
    this.addServicesList.length = 0;

    if (this.jobDataService.trade.id == this.tradeTypes.Plumbing) {
      this.metaData.tapsJobTypes.forEach((jt: JobType) => {
        let alreadySelected: boolean = false;
        let invalidType: boolean = false;

        this.jobDataService.jobTypes.forEach(sjt => {
          if (sjt.productCode == jt.productCode) {
            alreadySelected = true;
          }
        });

        if (jt.route != 'triage') {
          invalidType = true;
        }

        if (alreadySelected == false && invalidType == false) {
          let selector: JobTypeSelector = new JobTypeSelector();
          selector.jobType = jt;
          selector.selected = false;
          this.addServicesList.push(selector);
        }
      });
    }

    this.jobDataService.trade.jobTypes.forEach((jt: JobType) => {
      let alreadySelected: boolean = false;
      let invalidType: boolean = false;

      this.jobDataService.jobTypes.forEach(sjt => {
        if (sjt.productCode == jt.productCode) {
          alreadySelected = true;
        }
      });

      if (jt.route != 'triage') {
        invalidType = true;
      }

      if (alreadySelected == false && invalidType == false) {
        let selector: JobTypeSelector = new JobTypeSelector();
        selector.jobType = jt;
        selector.selected = false;
        this.addServicesList.push(selector);
      }
    });
  } // updateAddServicesList

  private fixIndexes(): void {
    let questionIndex: number = 0;
    this.triageQuestions.forEach(q => {
      q.index = questionIndex;
      questionIndex += 1;
    });

    let jobIndex: number = 0;
    this.jobDataService.jobTypes.forEach(jt => {
      this.triageQuestions.forEach(q => {
        if (q.jobTypeIndex == jt.jobTypeIndex && q.jobTypeIndex != -100) {
          q.jobTypeIndex = jobIndex;
        }
      });
      jt.jobTypeIndex = jobIndex;

      jobIndex += 1;
    });
  } // fixIndexes

  public jumpToJobType(jobType: JobType): void {
    let index: number = 0;
    let goToIndex: number = -1;

    this.triageQuestions.forEach(q => {
      if (goToIndex == -1 && q.jobTypeIndex == jobType.jobTypeIndex) {
        goToIndex = index;
      }
      index += 1;
    });

    if (goToIndex > -1) {
      this.goToStep(goToIndex);
    }
  } // jumpToJobType

  public jobTypeSelectorClicked(selector: JobTypeSelector): void {
    if (selector.selected == false) {
      selector.selected = true;
    } else {
      selector.selected = false;
    }
  }

  public closeGoBackPopup(value: boolean): void {
    if (value == false) {
      this.toggleGoBackPopup(false);
      return;
    } else {

      let queryParamsObject: any = {};

      if (this.jobDataService.capability.hasMemberShip) {
        queryParamsObject.isMember = this.jobDataService.capability.memberShipConfig.answer;
      }

      // if it's a one service straight-through trade type it needs to go back to home here
      if (this.jobDataService.trade.jobTypes.length == 1) {
        this.router.navigate(['/home']);
      } else {
        queryParamsObject.trade = this.jobDataService.trade.urlID;
        queryParamsObject.postcode = this.jobDataService.postcode;

        this.router.navigate(['/start'], { queryParams: queryParamsObject });
      }
    }
  }

  public freeTextChange(): void {
    if (this.validateStep() == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }
  }

  public bookingPhotoSelected(input: any, files: FileList): void {
    let component = this;

    for (let i = 0; i < files.length; i++) {
      let file: File = files[i];
      let exists: boolean = false;

      component.bookingPhotos.forEach(f => {
        if (f.name == file.name) {
          exists = true;
        }
      });

      if (!exists && component.bookingPhotos.length < 5) {
        let p: BookingPhoto = new BookingPhoto(file.name, file);
        component.bookingPhotos.push(p);
      } else {
        if (component.bookingPhotos.length >= 5) {
          component.toastr.error('You can\'t choose more than 5 photos.', 'Error');
        }
      }
    }

    // clear file input
    input.value = '';

  } // bookingPhotoSelected

  public removeBookingPhoto(photo: BookingPhoto): void {
    let index: number = -1;

    for (let i = 0; i < this.bookingPhotos.length; i++) {
      if (this.bookingPhotos[i].name == photo.name) {
        index = i;
      }
    }

    if (index > -1) {
      this.bookingPhotos.splice(index, 1);
    }
  }

  public setAnswer(question: TriageQuestionData, answer: string, fullAnswer: string = ''): void {
    question.answer = answer;
    if (fullAnswer.length == 0) {
      question.fullAnswer = question.answer;
    } else {
      question.fullAnswer = fullAnswer;
    }

    this.checkAnswer(question);
    this.calculatePrice();
  }

  public checkAnswer(question: TriageQuestionData): void {
    if (question.question.modifiedBasePartsCost > 0) {
      if (question.question.modifiedBasePartsAnswer.length == 0 || question.question.modifiedBasePartsAnswer == question.answer) {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentBasePartsCost = question.question.modifiedBasePartsCost;
      } else {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentBasePartsCost = this.jobDataService.jobTypes[this.currentJobTypeIndex].partsCostBase;
      }
    } else {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].currentBasePartsCost = this.jobDataService.jobTypes[this.currentJobTypeIndex].partsCostBase;
    }

    if (question.question.modifiedPremiumPartsCost > 0) {
      if (question.question.modifiedPremiumPartsAnswer.length == 0 || question.question.modifiedPremiumPartsAnswer == question.answer) {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentPremiumPartsCost = question.question.modifiedPremiumPartsCost;
      } else {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentPremiumPartsCost = this.jobDataService.jobTypes[this.currentJobTypeIndex].partsCostPremium;
      }
    } else {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].currentPremiumPartsCost = this.jobDataService.jobTypes[this.currentJobTypeIndex].partsCostPremium;
    }

    if (question.question.modifiedAttendanceHours > 0) {
      if (question.question.modifiedAttendanceHoursAnswer.length == 0 || question.question.modifiedAttendanceHoursAnswer == question.answer) {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentAttendanceHours = question.question.modifiedAttendanceHours;
      } else {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentAttendanceHours = this.jobDataService.jobTypes[this.currentJobTypeIndex].attendanceHours;
      }
    } else {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].currentAttendanceHours = this.jobDataService.jobTypes[this.currentJobTypeIndex].attendanceHours;
    }

    if (question.question.modifiedHourlyMultiplier > 0) {
      if (question.question.modifiedHourlyMultiplierAnswer.length == 0 || question.question.modifiedHourlyMultiplierAnswer == question.answer) {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentHourlyMultiplier = question.question.modifiedHourlyMultiplier;
      } else {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentHourlyMultiplier = question.question.hourlyMultiplier;
      }
    } else {
      if (question.question.hourlyMultiplier > 0) {
        this.jobDataService.jobTypes[this.currentJobTypeIndex].currentHourlyMultiplier = question.question.hourlyMultiplier;
      }
    }

    if (this.validateStep() == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }
  } // checkAnswer

  public initBookingOption(window: number): void {
    this.currentBookingWindow = window;
    this.showBookingWindow = true;
    this.currentQuestion.show = false;
    this.selectedBookingDate = null;
    this.selectedBookingTime = null;
    this.showBackToQuestionsButtons = true;
    this.currentBookingOptionValid = false;

    this.currentWindowOutOfHours = false;
  }

  public calendarOpened(): void {
    if (this.outOfHoursEnabled) {
      let d: HTMLDivElement = document.createElement("div");
      d.className = 'outOfHoursDisclaimer';

      let t = document.createTextNode("* Highlighted dates will be charged at an out of hours rate.");
      d.appendChild(t);

      setTimeout(() => {
        let element = document.getElementsByTagName('mat-calendar');
        element[0].appendChild(d);
      });
    }

    let db: HTMLDivElement = document.createElement("div");
    db.className = 'outOfHoursDisclaimer blackout';

    let tb: Text = document.createTextNode("* Greyed out dates are not available.");
    db.appendChild(tb);

    setTimeout(() => {
      let element: HTMLCollectionOf<Element> = document.getElementsByTagName('mat-calendar');
      element[0].appendChild(db);
    });
  }

  public validateBookingOption(): void {
    if (this.selectedBookingDate == null || this.selectedBookingTime == null) {
      this.currentBookingOptionValid = false;
    } else {
      this.currentBookingOptionValid = true;
    }

    if (this.selectedBookingDate != null && this.isDateOutOfHours(this.selectedBookingDate)) {
      this.currentWindowOutOfHours = true;
    } else {
      this.currentWindowOutOfHours = false;
    }
  }

  public confirmBookingOption(): void {

    if (this.selectedBookingDate == null || this.selectedBookingTime == null) {
      this.toastr.error('Please select a valid date and time.', 'Error');
      return;
    }

    this.bookingWindows[this.currentBookingWindow].date = this.selectedBookingDate;
    this.bookingWindows[this.currentBookingWindow].time = this.selectedBookingTime;
    this.bookingWindows[this.currentBookingWindow].valid = true;
    this.closeBookingOption();

    if (this.outOfHoursEnabled) {
      this.calculatePrice();
    }

    if (this.validateStep(false) == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }
  }

  public validateOnChange(): void {
    if (this.validateStep(false) == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }
  }

  public closeBookingOption(): void {
    this.showBookingWindow = false;
    this.currentQuestion.show = true;
    this.showBackToQuestionsButtons = false;

    this.selectedBookingDate = null;
    this.selectedBookingTime = null;
  }

  public toggleTimeWindowDropdown(): void {
    if (this.showTimeWindowDropdown) {
      this.showTimeWindowDropdown = false;
    } else {
      this.showTimeWindowDropdown = true;
    }
  }

  public setTimeWindow(window: TimeWindow): void {
    this.selectedBookingTime = window;
    this.showTimeWindowDropdown = false;
    this.validateBookingOption();
  }

  public validateStep(showToast: boolean = true): boolean {
    if (this.currentQuestion == null) {
      return true;
    }

    if (this.currentQuestion.question.required == false) {
      return true;
    }

    switch (this.currentQuestion.question.questionTypeID) {
      case 1: // free text
        {
          if (this.currentQuestion.answer.length == 0) {
            if (showToast) { this.toastr.error('Please enter an answer.', 'Error'); }
            return false;
          }
        }
        break;

      case 2: // booking windows
        {
          if (this.bookingWindows[0].valid == false || this.bookingWindows[1].valid == false) {
            if (showToast) { this.toastr.error('Please enter your two preferred booking windows.', 'Error'); }
            return false;
          } else {
            if (this.bookingWindows[0].date.toDateString() == this.bookingWindows[1].date.toDateString()) {
              if (this.bookingWindows[0].time.toString() == this.bookingWindows[1].time.toString()) {
                if (showToast) { this.toastr.error('Please enter two different booking windows.', 'Error'); }
                return false;
              }
            }
          }
        }
        break;

      case 3: // contact details
        {
          this.calculatePrice();

          // customer name
          if (this.jobDataService.jobData.customerContact.contactName.length == 0) {
            if (showToast) { this.toastr.error('Please enter your name.', 'Error'); }
            return false;
          } else {
            if (/[/.:{(})?=@;."]/.test(this.jobDataService.jobData.customerContact.contactName) == true) {
              if (showToast) { this.toastr.error('Please enter a valid name.', 'Error'); }
              return false;
            }
          }

          // site contact name
          if (this.jobDataService.jobData.siteContact.contactName.length == 0) {
            if (showToast) { this.toastr.error('Please enter your onsite contact name.', 'Error'); }
            return false;
          } else {
            if (/[/.:{(})?=@;."]/.test(this.jobDataService.jobData.siteContact.contactName) == true) {
              if (showToast) { this.toastr.error('Please enter a valid onsite contact name.', 'Error'); }
              return false;
            }
          }

          // customer email
          if (this.jobDataService.jobData.customerContact.contactEmail.length == 0) {
            if (showToast) { this.toastr.error('Please enter your email address.', 'Error'); }
            return false;
          } else {
            if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.jobDataService.jobData.customerContact.contactEmail) == false) {
              if (showToast) { this.toastr.error('Please enter a valid email address.', 'Error'); }
              return false;
            }
          }

          if (this.jobDataService.jobData.customerContact.contactEmail != this.confirmEmail) {
            if (showToast) { this.toastr.error('Email must match confirm email.', 'Error'); }
            return false;
          }

          // customer phone number
          if (this.jobDataService.jobData.customerContact.contactPhone.length == 0) {
            if (showToast) { this.toastr.error('Please enter your contact phone number.', 'Error'); }
            return false;
          } else {
            if (/[a-zA-Z:/@.'";=?]/.test(this.jobDataService.jobData.customerContact.contactPhone) == true) {
              if (showToast) { this.toastr.error('Please enter a valid phone number.', 'Error'); }
              return false;
            }
          }

          if (this.clientID == this.clients.AANZ && this.showMembershipInput()) {
            if (this.jobDataService.capability.memberShipConfig.memberNumber.length > 16) {
              if (showToast) { this.toastr.error('AA member number can\'t be more than 16 characters.', 'Error'); }
              return false;
            }
          }

          // site contact phone number
          if (this.jobDataService.jobData.siteContact.contactPhone.length == 0) {
            if (showToast) { this.toastr.error('Please enter your onsite contact phone number.', 'Error'); }
            return false;
          } else {
            if (/[a-zA-Z:/@.'";=?]/.test(this.jobDataService.jobData.siteContact.contactPhone) == true) {
              if (showToast) { this.toastr.error('Please enter a valid onsite contact phone number.', 'Error'); }
              return false;
            }
          }

          // member number
          if (this.showMembershipInput()) {
            const memberNumber = this.jobDataService.capability.memberShipConfig.memberNumber;

            if (!memberNumber) {
              if (showToast) { this.toastr.error('Please enter your member number.', 'Error'); }
              return false;
            }
          }

          // home address
          if (this.jobDataService.jobData.streetAddress.length == 0) {
            if (showToast) { this.toastr.error('Please enter your street address.', 'Error'); }
            return false;
          }

          // subrub name will come from google autocomplete
          if (this.jobDataService.jobData.suburbName.length == 0) {
            if (showToast) { this.toastr.error('Please enter your suburb.', 'Error'); }
            return false;
          }

          // postcode will come from google autocomplete
          if (this.jobDataService.jobData.postcode.length == 0) {
            if (showToast) { this.toastr.error('Please enter your postcode.', 'Error'); }
            return false;
          } else {
            if (isNaN(Number(this.jobDataService.jobData.postcode)) == true) {
              if (showToast) { this.toastr.error('Please enter a valid postcode.', 'Error'); }
              return false;
            } else {
              // validate postcode coverage
              let check = this.metaData.IsPostcodeCovered(this.jobDataService.jobData.postcode);

              if (check == false) {
                if (showToast) { this.toastr.error('Your postcode is not currently covered by our service.', 'Error'); }
                return false;
              }
            }
          }

          if (this.agreeTermsPrivacy == false) {
            if (showToast) { this.toastr.error('To continue, you must agree to our Terms and Privacy Policy.', 'Error'); }
            return false;
          }

          // if (this.agreePriceEstimate == false && this.pricingInfoEnabled) {
          //   if (showToast) { this.toastr.error('To continue, you must agree that you understand your price is an estimate.', 'Error'); }
          //   return false;
          // }

          if (this.agreeCallout == false && this.clientID == this.clients.AANZ) {
            if (showToast) { this.toastr.error('To continue, you must agree that a tradesperson attending the property is a chargable event.', 'Error'); }
            return false;
          }

          if (this.agreePayment == false && this.clientID == this.clients.AANZ) {
            if (showToast) { this.toastr.error('To continue, you must agree payment is required within 24 hours of the completed works.', 'Error'); }
            return false;
          }

          // if (this.agreeCovid == false && this.clientID == this.clients.AANZ ) {
          //   if (showToast) { this.toastr.error('To continue, you must agree that it Covid Safe for our tradesperson to attend.', 'Error'); }
          //   return false;
          // }

          // if (this.agreeDogs == false && this.clientID == this.clients.AANZ ) {
          //   if (showToast) { this.toastr.error('To continue, you must agree that all dogs at the property will be restrained for the duration of the inspection.', 'Error'); }
          //   return false;
          // }

        }
        break;

      case 4: // confirmation
        {
          // not needed on this step
        }
        break;

      case 5: // quantity
        {
          // not needed on this step
        }
        break;

      case 6: // 2 options
        {
          if (this.currentQuestion.answer.length == 0) {
            if (showToast) { this.toastr.error('Please select an option.', 'Error'); }
            return false;
          }
        }
        break;

      case 7: // select tap model
        {
          // not needed on this step
        }
        break;

      case 8: // numeric
        {
          // not needed on this step
        }
        break;

      case 9: // yes/no
        {
          if (this.currentQuestion.answer.length == 0) {
            if (showToast) { this.toastr.error('Please select an option.', 'Error'); }
            return false;
          }
        }
        break;

      case 10: // simple 2 options
        {
          if (this.currentQuestion.answer.length == 0) {
            if (showToast) { this.toastr.error('Please select an option.', 'Error'); }
            return false;
          }
        }
        break;

      case 11: // handyman duration
        {
          if (this.currentQuestion.answer.length == 0) {
            if (showToast) { this.toastr.error('Please select an option.', 'Error'); }
            return false;
          }
        }
        break;

      case 12: // Job notes & photos
        {
          // not mandatory
        }
        break;

      case 35: // dwelling type
        {
          if (this.currentQuestion.answer.length == 0) {
            if (showToast) { this.toastr.error('Please select an option.', 'Error'); }
            return false;
          }
        }
        break;
    }

    return true;
  }

  public nextStep(stepIndex: number, showPopups: boolean = true): void {
    if (stepIndex >= (this.triageQuestions.length - 1)) {
      return;
    }

    if (this.validateStep() == false) {
      this.currentQuestion.valid = false;
      return;
    } else {
      this.currentQuestion.valid = true;
    }

    if (showPopups) {
      if (this.triageQuestions[stepIndex].question.nextPopup.length > 0 && this.triageQuestions[stepIndex].popupShown == false) {
        this.showPopup = true;
        this.popupContent = this.triageQuestions[stepIndex].question.nextPopup;
        this.triageQuestions[stepIndex].popupShown = true;
        return; // user will get to the next step by closing the popup
      } else if (
        this.triageQuestions[stepIndex].question.nextPopupKey != null
        && this.triageQuestions[stepIndex].question.nextPopupKey.length > 0
        && this.triageQuestions[stepIndex].popupShown == false) {
        this.showPopup = true;
        this.popupContent = this.languageService.getString(this.triageQuestions[stepIndex].question.nextPopupKey);
        return;
      }
    }

    this.triageQuestions[stepIndex].show = false;
    this.triageQuestions[stepIndex + 1].show = true;
    this.currentQuestion = this.triageQuestions[stepIndex + 1];
    this.metaData.currentTriageQuestion = this.currentQuestion;

    if (this.currentQuestion.jobTypeIndex != null && this.currentQuestion.jobTypeIndex > -1) {
      this.currentJobTypeIndex = this.currentQuestion.jobTypeIndex;
    }

    window.scrollTo(0, 0);
    //document.getElementById("stepCountContainer").scrollIntoView();

    this.location.go('/triage?jobType=' + this.jobDataService.jobTypes[this.currentJobTypeIndex].productCode + '&stepType=' + this.currentQuestion.question.questionTypeID);

    // append member flag to params if req
    let isMemberString: string = "";
    if (this.jobDataService.capability.hasMemberShip) {
      isMemberString = "&isMember=" + this.jobDataService.capability.memberShipConfig.answer;
    }
    if (environment.GATrackingID.length > 0) {
      this.location.go('/triage?jobType=' + this.jobDataService.jobTypes[this.currentJobTypeIndex].productCode + '&stepType=' + this.currentQuestion.question.questionTypeID);
    }

    if (this.triageQuestions[stepIndex + 1].question.startPricing == true) {
      this.calculatingPrice = true;
    }

    // move up the progress bar if needed
    this.stepsProgress[this.triageQuestions[stepIndex + 1].question.progressStep - 1] = true;

    if (this.validateStep(false) == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }

    this.calculatePrice();
  } // next step

  public prevStep(stepIndex: number): void {
    if (stepIndex <= 0) {
      this.toggleGoBackPopup(true);
      return;
    }

    /* if (this.validateStep() == false) { don't think I should validate on back button
      return;
    } */

    this.triageQuestions[stepIndex].show = false;
    this.triageQuestions[stepIndex - 1].show = true;
    this.currentQuestion = this.triageQuestions[stepIndex - 1];
    this.metaData.currentTriageQuestion = this.currentQuestion;

    if (this.currentQuestion.jobTypeIndex != null && this.currentQuestion.jobTypeIndex > -1) {
      this.currentJobTypeIndex = this.currentQuestion.jobTypeIndex;
    }

    window.scrollTo(0, 0);
    //document.getElementById("stepCountContainer").scrollIntoView();

    // append member flag to params if req
    let isMemberString: string = "";
    if (this.jobDataService.capability.hasMemberShip) {
      isMemberString = "&isMember=" + this.jobDataService.capability.memberShipConfig.answer;
    }
    if (environment.GATrackingID.length > 0) {
      this.location.go('/triage?jobType=' + this.jobDataService.jobTypes[this.currentJobTypeIndex].productCode + '&stepType=' + this.currentQuestion.question.questionTypeID);
    }

    this.calculatePrice();
  } // prev step

  public goToStep(index: number) {
    if (this.currentQuestion.index < index) {
      if (this.validateStep() == false) {
        this.currentQuestion.valid = false;
        return;
      } else {
        this.currentQuestion.valid = true;
      }
    }

    if (this.currentQuestion.index == index) {
      return;
    }

    this.currentQuestion.show = false;
    this.currentQuestion = this.triageQuestions[index];
    this.metaData.currentTriageQuestion = this.currentQuestion;
    this.currentQuestion.show = true;

    if (this.currentQuestion.jobTypeIndex != null && this.currentQuestion.jobTypeIndex > -1) {
      this.currentJobTypeIndex = this.currentQuestion.jobTypeIndex;
    }

    // append member flag to params if req
    let isMemberString: string = "";
    if (this.jobDataService.capability.hasMemberShip) {
      isMemberString = "&isMember=" + this.jobDataService.capability.memberShipConfig.answer;
    }
    if (environment.GATrackingID.length > 0) {
      this.location.go('/triage?jobType=' + this.jobDataService.jobTypes[this.currentJobTypeIndex].productCode + '&stepType=' + this.currentQuestion.question.questionTypeID);
    }

    this.showMoreDetails = false;
    this.showFAQ = false;
    this.showBackToQuestionsButtons = false;

    // move up the progress bar if needed
    this.stepsProgress[this.triageQuestions[index].question.progressStep - 1] = true;

    window.scrollTo(0, 0);
    //document.getElementById("stepCountContainer").scrollIntoView();
    this.calculatePrice();
  } // go to step

  public closePopup(): void {
    this.showPopup = false;
    this.nextStep(this.currentQuestion.index, false);
  }

  public closePopupWithoutConfirm(): void {
    // 20220718 - MM - make sure we require user to confirm popup before proceeding
    this.triageQuestions[this.currentQuestion.index].popupShown = false;
    this.showPopup = false;
  }

  public openTermsPopup(): void {
    this.popupService.openSpecialPopup(this.specialPopupType.TermsAndConditions);
  }

  public openPrivacyPopup(): void {
    this.popupService.openSpecialPopup(this.specialPopupType.PrivacyPolicy);
  }

  public closeTermsPopup(): void {
    this.popupService.closeSpecialPopup(this.specialPopupType.TermsAndConditions);
  }

  public closePrivacyPopup(): void {
    this.popupService.closeSpecialPopup(this.specialPopupType.PrivacyPolicy);
  }

  public closeMobileInfoStep(): void {
    this.currentQuestion.show = true;
    this.showMoreDetails = false;
    this.showFAQ = false;
    this.showBackToQuestionsButtons = false;
  }

  public goToStepType(type: number): void {
    let questionIndex: number = 0;
    let goIndex: number = -1;

    this.triageQuestions.forEach(q => {
      if (q.question.questionTypeID == type) {
        goIndex = questionIndex;
      }
      questionIndex += 1;
    });

    if (goIndex > -1) {
      if (this.currentQuestion.index < goIndex) {
        if (this.validateStep() == false) {
          this.currentQuestion.valid = false;
          return;
        } else {
          this.currentQuestion.valid = true;
        }
      }

      this.goToStep(goIndex);
    }
  }

  public confirmBooking(): void {
    this.showEndPopup = true;
  }

  public showMembershipInput(): boolean {
    let result: boolean = false;
    if (this.jobDataService.capability.hasMemberShip) {
      result = this.jobDataService.capability.memberShipConfig.answer;
    }
    return result;
  }

  public getMemberShipNumber(): string {
    let result: string;
    if (this.jobDataService.capability.hasMemberShip) {
      result = this.jobDataService.capability.memberShipConfig.memberNumber;
    }
    return result;
  }

  public hideEndPopup(): void {
    this.showEndPopup = false;
  }

  public closeEndPopup(): void {

    let postcodeCheck = this.metaData.IsPostcodeCovered(this.jobDataService.jobData.postcode);

    if (postcodeCheck == false) {
      return;
    }

    let component: any = this;
    let newJobRef = 1001;
    let jobService = this.jobDataService;
    let questions = this.triageQuestions;
    let metaData = this.metaData;
    let db = this.db;
    let router = this.router;
    let toastr = this.toastr;
    let bookingWindows = this.bookingWindows;
    let price = this.currentPrice;
    let hours = this.estimatedDuration;
    let siteContactSameAsBooking = this.siteContactSameAsBooking;
    let questionTypes = this.questionTypes;

    this.endLoading = true;

    // 20220617 - MM - prevent double-clicks from creating multiple jobs by disabling button after first click (flag disabled in catch block)
    if (component.confirmJobClicked) {
      return;
    } else {
      component.confirmJobClicked = true;
    }

    let latestBooking = this.db.collection('/jobrefs').ref.orderBy('jobref', 'desc').limit(1);

    latestBooking.get().then(function (results) {
      if (!results.empty) {
        newJobRef = (results.docs[0].data().jobref + 1);
      }

      jobService.jobData.services = [];

      let jobTypeIndex: number = 0;

      // MM - grab description from inside loop to add as its own TriageResponseItem below
      let descriptionString = '';
      let overwriteDescription = false;

      jobService.jobTypes.forEach(jt => {
        let newService: HomeServiceItem = new HomeServiceItem();
        newService.externalServiceID = jt.productCode;
        newService.estimatedPrice = parseFloat((jt.estimatedCurrentPrice / (1 + environment.GST)).toFixed(2)); // ex GST price
        newService.estimatedDuration = jt.estimatedDuration;

        if (jobService.trade.id == component.tradeTypes.HomeInspections) {
          questions.forEach(function (q) {
            // if the question belongs to the current job type
            if (q.jobTypeIndex == jobTypeIndex && q.question.outgoingField) {
              // for home inspections the question is in the data field
              newService.triageResponses.push(new TriageResponseItem(q.question.questionTypeID, q.answer, q.question.data, q.fullAnswer));
            }
          });
        } else {
          let triageItem: TriageResponseItem = new TriageResponseItem(0, '', jt.productCode, '', true);
          let triageNote: string = '';

          triageItem.inclusionData = new InclusionData();
          triageItem.inclusionData.header = jt.name;



          questions.forEach(function (q) {

            // MM - extract description so we can add it as a separate job note
            if (q.question.questionTypeID == questionTypes.FreeText && !jt.showGeneralNotes) {
              descriptionString = q.fullAnswer;
              if (descriptionString == null || descriptionString.length == 0) {
                descriptionString = q.answer;
                overwriteDescription = true;
              }
            }

            // if the question belongs to the current job type
            if (q.jobTypeIndex == jobTypeIndex && q.question.outgoingField) {
              let questionNote: string = q.fullAnswer;
              if (questionNote == null || questionNote.length == 0) {
                questionNote = q.answer;
              }

              triageNote += q.question.description + ': ' + questionNote + ' ';
              triageItem.triageAnswer = triageNote;
              triageItem.triageFullAnswer = triageNote;

              let newInclusionSection: InclusionSection = new InclusionSection();
              newInclusionSection.question = q.question.description;
              newInclusionSection.answer = questionNote;
              triageItem.inclusionData.sections.push(newInclusionSection);

            }
          });

          newService.triageResponses.push(triageItem);

        }


        jobTypeIndex += 1;
        jobService.jobData.services.push(newService);
      });

      jobService.addedJobRef = newJobRef;

      // temporary sun50 offer
      if (component.applyFlatDiscount == true) {
        price += component.flatDiscount; // send it through without the displayed discount so it can be handled in easylink
      }

      let exGST: number = price / (1 + environment.GST);

      jobService.jobData.estimatedPrice = parseFloat(exGST.toFixed(2));
      jobService.jobData.estimatedHours = hours;
      jobService.addedJobEstimate = jobService.jobData.estimatedPrice;

      if (siteContactSameAsBooking) {
        jobService.jobData.siteContact.contactName = jobService.jobData.customerContact.contactName;
        jobService.jobData.siteContact.contactPhone = jobService.jobData.customerContact.contactPhone;
      }

      let window1: JobBookingWindow = new JobBookingWindow();
      let window2: JobBookingWindow = new JobBookingWindow();
      if (component.bookingWindowsEnabled) {

        window1.date = bookingWindows[0].date;
        window1.time = new JobTimeWindow();
        window1.time.from = bookingWindows[0].time.from;
        window1.time.to = bookingWindows[0].time.to;

        window2.date = bookingWindows[1].date;
        window2.time = new JobTimeWindow();
        window2.time.from = bookingWindows[1].time.from;
        window2.time.to = bookingWindows[1].time.to;

      } else {

        // 20220926 - MM - substitute dummy data for booking window (2 weeks from booking date)
        let numBlackoutDays = 14;
        var dummyDate = new Date();
        dummyDate.setDate(dummyDate.getDate() + numBlackoutDays);
        var dummyFromTime = '10:30 AM';
        var dummyToTime = '12:30 PM';

        window1.date = dummyDate;
        window1.time = new JobTimeWindow();
        window1.time.from = dummyFromTime;
        window1.time.to = dummyToTime;

        window2.date = dummyDate;
        window2.time = new JobTimeWindow();
        window2.time.from = dummyFromTime;
        window2.time.to = dummyToTime;

      }

      jobService.jobData.services[0].triageResponses.push(new TriageResponseItem(0, JobChannelType[jobService.jobChannel], 'Booking Channel', JobChannelType[jobService.jobChannel]));

      // end popup answer and booking windows added as questions to the first job type
      if (component.bookingWindowsEnabled) {
        // 20220928 - MM - no need to add this data as a triage response if booking windows are turned off
        jobService.jobData.services[0].triageResponses.push(new TriageResponseItem(0, bookingWindows[0].date.toDateString() + ' ' + bookingWindows[0].time.toString(), 'Booking window 1', bookingWindows[0].date.toDateString() + ' ' + bookingWindows[0].time.toString()));
        jobService.jobData.services[0].triageResponses.push(new TriageResponseItem(0, bookingWindows[1].date.toDateString() + ' ' + bookingWindows[1].time.toString(), 'Booking window 2', bookingWindows[1].date.toDateString() + ' ' + bookingWindows[1].time.toString()));
      }

      let addedGeneralNotes: boolean = false;

      questions.forEach(function (q) {
        // if the question belongs to the current job type
        if (!addedGeneralNotes && q.jobTypeIndex == -100 && q.question.questionTypeID == questionTypes.JobNotesPhotos) {
          let questionNote: string = q.fullAnswer;
          if (questionNote == null || questionNote.length == 0) {
            questionNote = q.answer;
          }

          if (overwriteDescription) {
            // MM - for AA jobs, we need to do this so the description appears as its own job note, due to use of the free text field
            jobService.jobData.services[0].triageResponses.push(new TriageResponseItem(0, descriptionString, q.question.description, descriptionString, false));
          } else {
            jobService.jobData.services[0].triageResponses.push(new TriageResponseItem(0, questionNote, q.question.description, questionNote));
          }
        }
      });


      let packageJobData: JobData = JSON.parse(JSON.stringify(jobService.jobData));

      if (packageJobData.streetUnit.length > 0) {
        packageJobData.streetAddress = packageJobData.streetUnit + '/' + packageJobData.streetAddress;
      }

      packageJobData.bookingWindows = [];
      packageJobData.bookingWindows.push(window1);
      packageJobData.bookingWindows.push(window2);

      let now: Date = new Date();
      let membershipNumber: string = component.getMemberShipNumber();

      if (component.jobDataService.capability.hasMemberShip == true && membershipNumber == null) {
        membershipNumber = '';
      }

      let newBooking: any = {};
      newBooking.jobref = newJobRef;
      newBooking.data = JSON.stringify(packageJobData);
      newBooking.processed = false;
      newBooking.processedDate = null;
      newBooking.insertedDate = new Date(now.toUTCString());
      newBooking.bookingType = jobService.trade.bookingType;
      // temporary mortgage HIP offer code / the block offer code
      newBooking.offerCode = jobService.offerCode;
      newBooking.channel = jobService.jobChannel;
      newBooking.marketingOptIn = component.marketingOptIn;
      newBooking.whereDidYouHearAboutUs = component.whereDidYouHearAboutUs;

      if (component.jobDataService.capability.hasMemberShip == true) {
        newBooking.membershipNumber = component.getMemberShipNumber();
      }

      newBooking.tries = 0;

      let newRef: any = {};
      newRef.jobref = newJobRef;

      db.doc('/bookings/' + environment.jobPrefix + '_' + newJobRef.toString()).set(newBooking).then(function () {
        db.doc('/jobrefs/' + environment.jobPrefix + '_' + newJobRef.toString()).set(newRef).then(function () {
          let photoIndex: number = 0;

          component.bookingPhotos.forEach(p => {
            let newPhoto: any = {};
            newPhoto.jobref = newJobRef;
            newPhoto.name = p.name;
            newPhoto.data = p.base64;
            newPhoto.processed = false;
            newPhoto.tries = 0;
            newPhoto.processedDate = null;

            db.doc('/bookingphotos/' + environment.jobPrefix + '_' + newJobRef.toString() + '_' + photoIndex).set(newPhoto).then(function () { });

            photoIndex += 1;
          });

          component.endLoading = false;

          let queryParamsObject: any = {};
          if (jobService.capability.hasMemberShip) {
            queryParamsObject.isMember = jobService.capability.memberShipConfig.answer;
          }

          if (jobService.trade.id == component.tradeTypes.HomeInspections) {
            router.navigate(['/completeinspection']);
          } else {
            router.navigate(['/complete'], { queryParams: { jobType: ''/*jobService.jobType.productCode TODO: fix complete step product code*/ } });
          }
        });

      }).catch(function (error) {
        toastr.error('Booking failed, please try again.');
        console.log('ERROR: ' + error);
        component.confirmJobClicked = false;
        component.endLoading = false;
      });
    }).catch(function (error) {
      toastr.error('Booking failed, please try again.');
      console.log('ERROR: ' + error);
      component.confirmJobClicked = false;
      component.endLoading = false;
    });
  } // closeEndPopup

  public selectModel(modelName: string, question: TriageQuestionData): void {
    if (modelName == 'standard') {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].standardModel = true;
      question.answer = 'standard';
      question.fullAnswer = question.answer;
    } else {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].standardModel = false;
      question.answer = 'premium';
      question.fullAnswer = question.answer;
    }

    if (this.validateStep() == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }

    this.calculatePrice();
  }

  public updateNumAnswer(question: TriageQuestionData, amount: number): void {
    let currentAmount: number = parseFloat(question.answer);
    currentAmount += amount;

    if (currentAmount < 1) {
      currentAmount = 1;
    }

    question.answer = currentAmount.toString();
    question.fullAnswer = question.answer;

    if (this.currentQuestion.question.quantity) {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].currentQuantity = currentAmount;
    }

    if (question.question.hourlyMultiplier > 0 && this.jobDataService.jobTypes[this.currentJobTypeIndex].currentHourlyMultiplier == null) {
      this.jobDataService.jobTypes[this.currentJobTypeIndex].currentHourlyMultiplier = question.question.hourlyMultiplier;
    }

    if (this.validateStep() == false) {
      this.currentQuestion.valid = false;
    } else {
      this.currentQuestion.valid = true;
    }

    this.calculatePrice();
  }

  public ignoreTradeTypePricingForThisJobType(jobTypeID: number) {
    
    let ignoreTradePricing = false;

    if (this.clientID == this.clients.AANZ) {

      // MM - AANZ want to ignore the usual hourly rate and callout fee for certain job types (Mitre 10 BAJ Changes, March/April 2024)
      const jobTypesWhichIgnoreTradePricing = [
        this.jobTypes.DishwasherInstallationWithOptionalDisposal,
        this.jobTypes.OvenInstallationWithOptionalDisposal,
        this.jobTypes.ToiletInstallationWithOptionalDisposal,
        this.jobTypes.VanityInstallationWithOptionalDisposal,
        this.jobTypes.InstallingAirConditioningHeatPump,
        this.jobTypes.ExtractorFanInstallation,
        this.jobTypes.ExternalPowerPointInstallation,
        this.jobTypes.InternalPowerPointInstallation,
        this.jobTypes.LightSwitchInstallation,
      ];

      ignoreTradePricing = jobTypesWhichIgnoreTradePricing.includes(jobTypeID);
    }

    return ignoreTradePricing;

  }

  public calculatePrice(): void {
    if (this.calculatingPrice == false) {
      return;
    }

    let isOutOfHours: boolean = false;

    if (this.outOfHoursEnabled) {
      if (this.isOutOfHours(this.bookingWindows[0]) || this.isOutOfHours(this.bookingWindows[1])) {
        isOutOfHours = true;
      }
    }

    let component = this;
    component.fullPrice = 0;
    component.currentPrice = 0;
    component.estimatedDuration = 0;

    let jobTypesProcessed: number = 0;

    this.jobDataService.jobTypes.forEach(jt => {
      let newPrice: number = 0;
      let newDuration: number = 0;

      let additionalCalloutFee: number = 0;
      let calloutFee: number = component.jobDataService.trade.calloutFee;
      let hourlyRate: number = component.jobDataService.trade.hourlyRate;
      let attendanceHours: number = jt.currentAttendanceHours;
      let hourlyMultiplier: number = (jt.currentHourlyMultiplier == null ? attendanceHours : jt.currentHourlyMultiplier);
      let basePartsCost: number = jt.currentBasePartsCost;
      let premiumPartsCost: number = jt.currentPremiumPartsCost;
      let adminFee: number = environment.flatAdminFee;
      let flatFee: number = 0;

      if (isOutOfHours) {
        if (component.jobDataService.trade.oohCalloutFee != null) {
          calloutFee = component.jobDataService.trade.oohCalloutFee;
        }

        if (component.jobDataService.trade.oohHourlyRate != null) {
          hourlyRate = component.jobDataService.trade.oohHourlyRate;
        }

        if (jt.oohAttendanceHours != null) {
          attendanceHours = jt.oohAttendanceHours;
        }

        component.outOfHoursPriceApplied = true;
      } else {
        component.outOfHoursPriceApplied = false;
      }

      if (jt.calloutFee > 0) {
        calloutFee = jt.calloutFee;

        if (isOutOfHours && jt.oohCalloutFee != null) {
          calloutFee = jt.oohCalloutFee;
        }
      }

      // #region APPLY REGION/POSTCODE BASED PRICING
      let tradeTypePricing = component.metaData.GetTradeTypePricing(component.jobDataService.trade.id, component.jobDataService.postcode);
      let jobTypePricing = component.metaData.GetJobTypePricing(component.jobDataService.trade.id, jt.id, component.jobDataService.postcode);
      let tradeTypePricingChange = component.metaData.GetPricingChangeByTradeTypeID(component.jobDataService.trade.id, component.jobDataService.postcode);

      

      if (tradeTypePricing != null) {

        if (tradeTypePricing.HourlyRate != null) {
          hourlyRate = tradeTypePricing.HourlyRate;
          hourlyRate = hourlyRate / 100;
        }

        if (tradeTypePricing.CalloutFee != null) {
          calloutFee = tradeTypePricing.CalloutFee;
          calloutFee = calloutFee / 100;
        }

        if (isOutOfHours) {
          if (tradeTypePricing.OutOfHoursHourlyRate != null) {
            hourlyRate = tradeTypePricing.OutOfHoursHourlyRate;
            hourlyRate = hourlyRate / 100;
          }

          if (tradeTypePricing.OutOfHoursCalloutFee != null) {
            calloutFee = tradeTypePricing.OutOfHoursCalloutFee;
            calloutFee = calloutFee / 100;
          }
        }

        if (tradeTypePricing.AdditionalCalloutFee != null) {
          additionalCalloutFee = tradeTypePricing.AdditionalCalloutFee;
          additionalCalloutFee = additionalCalloutFee / 100;
        }
      }
      

      if (jobTypePricing != null) {
        
        // reset pricing if we're ignoring trade type pricing
        if (this.ignoreTradeTypePricingForThisJobType(jobTypePricing.JobTypeID)) {
          calloutFee = 0.00;
          hourlyRate = 0.00;
          additionalCalloutFee = 0.00;
        }

        if (jobTypePricing.PartsCostBase != null) {
          basePartsCost = jobTypePricing.PartsCostBase;
          basePartsCost = basePartsCost / 100;
        }

        if (jobTypePricing.PartsCostPremium != null) {
          premiumPartsCost = jobTypePricing.PartsCostPremium;
          premiumPartsCost = premiumPartsCost / 100;
        }

        if (jobTypePricing.AttendanceHours != null) {
          attendanceHours = jobTypePricing.AttendanceHours;
        }

        if (jobTypePricing.HourlyRate != null) {
          hourlyRate = jobTypePricing.HourlyRate;
          hourlyRate = hourlyRate / 100;
        }

        if (jobTypePricing.CalloutFee != null) {
          calloutFee = jobTypePricing.CalloutFee;
          calloutFee = calloutFee / 100;
        }

        if (isOutOfHours) {
          if (jobTypePricing.OutOfHoursHourlyRate != null) {
            hourlyRate = jobTypePricing.OutOfHoursHourlyRate;
            hourlyRate = hourlyRate / 100;
          }

          if (jobTypePricing.OutOfHoursCalloutFee != null) {
            calloutFee = jobTypePricing.OutOfHoursCalloutFee;
            calloutFee = calloutFee / 100;
          }
        }

        if (jobTypePricing.AdditionalCalloutFee != null) {
          additionalCalloutFee = jobTypePricing.AdditionalCalloutFee;
          additionalCalloutFee = additionalCalloutFee / 100;
        }
      }

      if (tradeTypePricingChange != null) {
        if (tradeTypePricingChange.AddFlatFee != null && tradeTypePricingChange.AddFlatFee.length > 0) {
          flatFee += parseFloat(tradeTypePricingChange.AddFlatFee);
        }

        if (tradeTypePricingChange.AddHourlyRate != null && tradeTypePricingChange.AddHourlyRate.length > 0) {
          hourlyRate += parseFloat(tradeTypePricingChange.AddHourlyRate);
        }

        if (tradeTypePricingChange.AddCalloutFee != null && tradeTypePricingChange.AddCalloutFee.length > 0) {
          calloutFee += parseFloat(tradeTypePricingChange.AddCalloutFee);
        }
      }
      // #endregion

      // RAC temporary discount
      let discountPercent: number = 0;
      let newFullPrice: number = 0;
      let fullCalloutFee: number = calloutFee;
      let fullHourlyRate: number = hourlyRate;
      let fullAdminFee: number = environment.flatAdminFee;

      if (this.jobDataService.capability.hasMemberShip && this.jobDataService.capability.memberShipConfig.answer) {
        discountPercent = this.jobDataService.capability.memberShipConfig.discount;

        if (tradeTypePricing.OverrideMemberDiscountPercent) {
          discountPercent = parseFloat(tradeTypePricing.OverrideMemberDiscountPercent);
        }
      }

      // only apply the callout fee for the first job
      if (jobTypesProcessed > 0) {
        calloutFee = 0;
        fullCalloutFee = 0;
      }

      newPrice += calloutFee + additionalCalloutFee;
      newPrice += hourlyRate * attendanceHours;

      // 20220615 - MM - AA have specified no admin fee applies to HH jobs
      if (!this.metaData.IsAAHomeInspection(this.jobDataService.trade.id)) {
        newFullPrice += fullAdminFee;
      }

      newFullPrice += fullCalloutFee + additionalCalloutFee;
      newFullPrice += fullHourlyRate * attendanceHours;

      let partsCost: number = basePartsCost;
      if (jt.standardModel == false) {
        partsCost = premiumPartsCost;
      }

      newPrice += partsCost;

      // RAC temporary discount
      newFullPrice += partsCost;

      newDuration += attendanceHours;

      let quantity: number = 0;

      component.triageQuestions.forEach(element => {
        if (element.jobTypeIndex == jt.jobTypeIndex) {
          if (element.question.quantity) {
            quantity = parseFloat(element.answer) - 1;

            if (quantity > 0) {
              let hoursPerQuantity: number = (hourlyMultiplier > 0 ? hourlyMultiplier : attendanceHours);
              newPrice += (hourlyRate * hoursPerQuantity) * quantity;
              newPrice += (jt.additionalPartsFree ? 0 : partsCost * quantity);
              newDuration += hoursPerQuantity * quantity;

              // RAC temporary discount
              newFullPrice += (fullHourlyRate * hoursPerQuantity) * quantity;
              newFullPrice += (jt.additionalPartsFree ? 0 : partsCost * quantity);
            }
          }

          if (element.question.additionalFixedCost > 0) {
            if (element.question.additionalFixedCostAnswer.length == 0 || element.question.additionalFixedCostAnswer == element.answer) {
              newPrice += element.question.additionalFixedCost;

              // RAC temporary discount
              newFullPrice += element.question.additionalFixedCost;
            }
          }

          if (element.question.additionalFixedCostAnswerMatrix != null) {
            element.question.additionalFixedCostAnswerMatrix.forEach(item => {
              if (element.answer == item.answer) {
                let itemPrice: number = item.price;

                newPrice += itemPrice;
                newFullPrice += item.price;
              }
            });
          }

          if (element.question.additionalPerCost > 0) {
            if (element.question.additionalPerCostAnswer.length == 0 || element.question.additionalPerCostAnswer == element.answer) {
              newPrice += element.question.additionalPerCost * (quantity + 1);

              // RAC temporary discount
              newFullPrice += element.question.additionalPerCost * (quantity + 1);
            }
          }
        }
      });

      newPrice += flatFee;
      newFullPrice += flatFee;

      let adminFeeAdded = false;

      let jobTypePricingChange: PricingChange = null;
      if (jobTypePricing && jobTypePricing.JobTypeID) {
        jobTypePricingChange = component.metaData.GetPricingChangeByJobTypeID(jobTypePricing.JobTypeID, component.jobDataService.postcode);
      }

      if (jobTypePricingChange && jt.currentQuantity > 1) {

        // override promo pricing for Air Con Maintenance promo March 2025  
        const totalForAdditionalUnits = parseFloat(jobTypePricingChange.AdditionalUnitCostOverrideNonMember) * (jt.currentQuantity - 1);
        newFullPrice = basePartsCost + totalForAdditionalUnits + adminFee;

        if (this.jobDataService.capability.hasMemberShip) {
          const discountOnFirstHour = basePartsCost * discountPercent;
          const discountedFirstHourCost = basePartsCost - discountOnFirstHour;
          const totalForAdditionalUnits = parseFloat(jobTypePricingChange.AdditionalUnitCostOverrideMember) * (jt.currentQuantity - 1);
          
          let adminFeeDiscount = adminFee * discountPercent;
          adminFee -= adminFeeDiscount;
          
          newPrice = discountedFirstHourCost + totalForAdditionalUnits + adminFee;

        } 

        adminFeeAdded = true;

      } else {
        
        // standard AANZ discount
        if (this.jobDataService.capability.hasMemberShip) {
  
          if (component.clientID == component.clients.AANZ && this.jobDataService.capability.memberShipConfig.answer) {
            let discount: number = newPrice * discountPercent;
            newPrice -= discount;
  
            let adminFeeDiscount = adminFee * discountPercent;
            adminFee -= adminFeeDiscount;
          }
        }
      }

      if (this.jobDataService.capability.hasMemberShip) {
        if (this.jobDataService.capability.memberShipConfig.answer) {
          component.discountApplied = true;
        } else {
          component.discountApplied = false;
        }
      }

      // 20220615 - MM - AA have specified that no admin fee applies to HH jobs
      if (!this.metaData.IsAAHomeInspection(this.jobDataService.trade.id) && !adminFeeAdded) {
        if (component.discountApplied) {
          newPrice += adminFee;
        } else {
          newPrice += fullAdminFee;
        }
      }

      // RAC temporary discount
      jt.estimatedFullPrice = newFullPrice;
      component.fullPrice += newFullPrice;

      jt.estimatedCurrentPrice = newPrice;
      component.currentPrice += newPrice;

      jt.estimatedDuration = newDuration;
      component.estimatedDuration += newDuration;

      jobTypesProcessed += 1;
    }); // for each job type

  } // calculatePrice

  public convertURLName(name: string) {
    let newName = name.split(' ').join('-');
    newName = newName.split('_').join('-');

    return newName.toLowerCase();
  }

  public expandFAQ(item: FAQItem): void {
    if (item.show) {
      item.show = false;
    } else {
      item.show = true;
    }
  } // expandFAQ

  public toggleMoreDetails(): void {
    if (this.showMoreDetails) {
      this.showMoreDetails = false;
      this.currentQuestion.show = true;
      this.showBackToQuestionsButtons = false;
    } else {
      this.showMoreDetails = true;
      this.currentQuestion.show = false;
      this.showBackToQuestionsButtons = true;
    }

    this.showBookingWindow = false;
    this.showFAQ = false;
  } // toggleMoreDetails

  public toggleFAQ(): void {
    if (this.showFAQ) {
      this.showFAQ = false;
      this.currentQuestion.show = true;
      this.showBackToQuestionsButtons = false;
    } else {
      this.showFAQ = true;
      this.currentQuestion.show = false;
      this.showBackToQuestionsButtons = true;
    }

    this.showBookingWindow = false;
    this.showMoreDetails = false;
  } // toggleFAQ

}

export class BookingWindow {
  public date: Date = null;
  public time: TimeWindow = null;
  public valid: boolean = false;
}

export class TimeWindow {
  public to: string;
  public from: string;
  public outOfHours: boolean;

  constructor(_from: string, _to: string, _outOfHours: boolean) {
    this.to = _to;
    this.from = _from;
    this.outOfHours = _outOfHours;
  }

  public toString = (): string => {
    return this.from + ' - ' + this.to;
  }
}

export class BookingPhoto {
  public data: Blob = null;
  public name: string = '';
  public base64: string = '';

  constructor(_name: string, _data: File) {
    let obj = this;

    this.base64 = 'assets/img/loading_spinner.gif';

    (<any>window).imageConversion.compressAccurately(_data, 600).then(res => {
      obj.data = res;
      obj.name = _name;

      let reader = new FileReader();

      reader.onloadend = function () {
        obj.base64 = reader.result.toString();
      }

      reader.readAsDataURL(obj.data);
    });
  }
}

export class JobTypeSelector {
  public jobType: JobType = null;
  public selected: boolean = false;
}
